import React, { useState } from 'react'
import { Input } from 'antd'
import styled from 'styled-components'
import { useLyricProcessor } from 'hooks/lyric'
import { useKaraoke } from 'hooks/karaoke'

const { TextArea } = Input

const TextInput = styled(TextArea)`
  height: 100% !important;
`

const useLyricsProcessor = (lyrics) => {
  const [value, setValue] = useState(lyrics)

  return [value, setValue]
}

export const LyricsInput = (props) => {
  const { setLyric, lyrics } = useLyricProcessor()
  const { currentStep } = useKaraoke()
  // const [lyrics, setLyrics] = useLyricsProcessor(lyrics)
  const onChange = (e) => {
    setLyric(e.target.value)
  }

  return (
    <TextInput value={lyrics} onChange={onChange} disabled={currentStep !== 0} />
  )
}
